function x(c, r) {
  return (i, o) => {
    const e = o.prefix.trim().match(c);
    if (e === null)
      return !0;
    const t = e[0].length, n = i.index - t, u = r.getText(n, t);
    return r.formatText(n, t, { link: u }, "user"), !0;
  };
}
export {
  x as createUrlKeyboardHandler
};
